/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type getRecentHistory_user = {
    readonly recentHistoryItems?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly contemporaryTrackingString: string;
                readonly firstPhotoWebPath: string | null;
                readonly pdpURL: string | null;
                readonly title: string | null;
                readonly browseUrl: string | null;
                readonly categoryCode: string | null;
                readonly serviceId: string | null;
                readonly categoryPath: string | null;
                readonly seller: {
                    readonly serviceId: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "getRecentHistory_user";
};
export type getRecentHistory_user$data = getRecentHistory_user;
export type getRecentHistory_user$key = {
    readonly " $data"?: getRecentHistory_user$data;
    readonly " $fragmentRefs": FragmentRefs<"getRecentHistory_user">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "getRecentHistory_user",
  "type": "User",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "recentHistoryItems"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUserRecentHistoryItem",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "localRecentHistoryItemIds",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUserRecentHistoryItem",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "recentHistoryItems",
          "name": "__getRecentHistory_recentHistoryItems_connection",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "excludeItemPks",
              "variableName": "localRecentHistoryItemIds"
            }
          ],
          "concreteType": "RecentHistoryItemsConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "RecentHistoryItemsEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Item",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "contemporaryTrackingString",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "firstPhotoWebPath",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "size",
                          "value": "small"
                        }
                      ],
                      "storageKey": "firstPhotoWebPath(size:\"small\")"
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "pdpURL",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "browseUrl",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "categoryCode",
                      "args": null,
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "categoryPath",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "seller",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Seller",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "__typename",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cursor",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "endCursor",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "hasNextPage",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '4b01444c8aa7cd585a9a368510d6b9d4';
export default node;
